<script setup lang="ts">
import TemplateTips from './TemplateTips.vue'

import { Loader2 } from 'lucide-vue-next'

import type { TemplateData, TemplateModule } from '@/types/types'

const props = defineProps<{
  module?: TemplateModule
  urlParams?: Record<string, string>
}>()
const { t } = useI18n()
const isLoaded = ref(false)
const isLoading = ref(false)

const templates = ref<TemplateData[]>([])

const computedModule = computed(() => {
  return props.module === 'legacy-contests' ? 'contests' : props.module
})

const { fetchTemplates, applyTemplate } = useTemplate()

const fetchData = async () => {
  templates.value = await fetchTemplates(computedModule.value)
  isLoaded.value = true
}

fetchData()
const redirectToModule = async () => {
  isLoading.value = true
  await applyTemplate(props.module, props.urlParams)
  isLoading.value = false
}
</script>
<template>
  <div v-if="isLoaded">
    <div>
      <TemplateTips v-if="templates.length > 0" :module="module" :templates="templates" :url-params="urlParams" />
      <div class="px-8 text-sm">
        <p class="my-8 font-semibold text-foreground">
          {{ t(`pages.${computedModule}.emptyState.startFromZero`) }}
        </p>
        <Button variant="default-primary" :disabled="isLoading" @click="redirectToModule">
          <Loader2 v-if="isLoading" class="animate-spin" />
          {{ t(`pages.${computedModule}.emptyState.button`) }}
        </Button>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="mb-6 flex flex-col rounded-sm border bg-muted px-8 pb-4 pt-8">
      <div class="flex justify-between">
        <AppSkeleton type="text" class="mb-6 h-3 w-1/3" />
        <AppSkeleton type="text" class="mb-6 h-3 w-1/3" />
      </div>
      <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        <AppSkeleton v-for="i in 5" :key="i" type="section" />
      </div>
    </div>
  </div>
</template>
